<mat-toolbar class="custom-header-toolbar border-bottom bg-white px-3">
  
  <!-- Bouton Menu Sidenav -->
  <button mat-icon-button (click)="changeSidenavState()" aria-label="Ouvrir le menu de navigation">
    <mat-icon>menu</mat-icon>
  </button>
  
  <!-- Logo / Lien Home -->
  <button mat-button routerLink="/home" class="brand-link-btn ms-2">
    <span class="fw-bold tracking-wide text-dark brand-text">SYGMA</span>
  </button>
  
  <span class="spacer flex-grow-1"></span>
  
  <!-- Badge d'affichage du Site Actuel -->
  <button mat-button routerLink="/home" color="primary" class="site-badge-btn px-3">
    @if (authService.getCurrentUser().user.site != null) {
      <span class="fw-semibold small">{{ (currentSygmaSite?currentSygmaSite+" - ":"") + (authService.getCurrentUser().user.site)?.name }}</span>
    } @else {
      <span class="fw-bold small text-danger tracking-wider">ROOT</span>
    }
  </button>
  
  <span class="spacer flex-grow-1"></span>
  
  <!-- Notifications / Relances -->
  <button [matMenuTriggerFor]="menuExcel" mat-icon-button matTooltip="Relancer des assurés" aria-label="Afficher les notifications de relances">
    <mat-icon [matBadge]="cpt()" [matBadgeColor]="alert() ? 'warn' : 'primary'">notifications</mat-icon>
  </button>
  
  <!-- Menu Utilisateur -->
  <button [matMenuTriggerFor]="menu" mat-icon-button aria-label="Ouvrir le menu utilisateur">
    <mat-icon>account_circle</mat-icon>
  </button>

</mat-toolbar>

<!-- Menus Déroulants -->
<mat-menu #menu="matMenu" class="custom-header-menu">
  <button mat-menu-item (click)="confirmLogout()">
    <mat-icon class="text-danger">logout</mat-icon>
    <span class="text-dark">Déconnexion</span>
  </button>
</mat-menu>

<mat-menu #menuExcel="matMenu" class="custom-header-menu" [hidden]="cpt() == 0">
  <button mat-menu-item (click)="printExcel()">
    <mat-icon color="primary">export_notes</mat-icon>
    <span>Exporter les relances</span>
  </button>
</mat-menu>
